import React from 'react';
import { User, MessageSquare, Calendar } from 'lucide-react';
import StarRating from './StarRating';

/**
 * Card individual de uma avaliação
 */
const ReviewCard = ({ review }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-zinc-900 rounded-lg p-5 border border-zinc-800">
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center">
            <User className="w-5 h-5 text-gray-400" />
          </div>
          <div>
            <p className="text-white font-medium">
              {review.user_name}
            </p>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <Calendar className="w-3 h-3" />
              {formatDate(review.created_at)}
            </div>
          </div>
        </div>
        <StarRating rating={review.rating} size="sm" />
      </div>

      {/* Comment */}
      {review.comment && (
        <p className="text-gray-300 text-sm leading-relaxed mb-3">
          "{review.comment}"
        </p>
      )}

      {/* Admin Response */}
      {review.admin_response && (
        <div className="mt-4 pl-4 border-l-2 border-red-600">
          <div className="flex items-center gap-2 mb-1">
            <MessageSquare className="w-4 h-4 text-red-500" />
            <span className="text-xs text-red-500 font-semibold">
              Resposta da AJ BIM
            </span>
          </div>
          <p className="text-gray-400 text-sm">
            {review.admin_response}
          </p>
        </div>
      )}
    </div>
  );
};

export default ReviewCard;
